import styled from "@emotion/styled";
import { Box, Card, css } from "@mui/material";

export const BoxContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #0299da;
`;

export const LoginCard = styled.form`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: flex-start;
    background: #fff;
    max-width: 400px;
    border-radius: 8px;
    padding: 32px;
  `}
`;

export const LoginImg = styled.img`
  align-self: center;
  width: 70%;
`;
